module.exports = {
  src: __webpack_public_path__ + "static/media/children_00021.4f9da073.jpg",
  width: 4800,
  height: 6000,
  bytes: 931775,
  type: "jpg",
};
module.exports.toString = function() {
  return __webpack_public_path__ + "static/media/children_00021.4f9da073.jpg";
};


//////////////////
// WEBPACK FOOTER
// ./src/core/images/galleries/children/children_00021.jpg
// module id = 223
// module chunks = 0